module.exports = __webpack_public_path__ + "f0d7d673ef06ec9cf090dc00572d63e4.otf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/fonts/HelveticaNeue/HelveticaNeueLTStd-Md.otf
// module id = 340
// module chunks = 0